import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import YesNo from '../../../../../assets/images/img_send-prompt-message.svg'
import ApproveDraftInReviewDialogViewModel from './ApproveDraftInReviewDialogViewModel'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'

interface Props {
  vm: ApproveDraftInReviewDialogViewModel
}

const ApproveDraftDialog = observer(({ vm }: Props) => {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentIllustration src={YesNo} />
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>
            Are you sure that you approve the latest draft return?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            If accepted, the Pro will be able to close the job.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="secondary" onClick={vm.close}>
            Cancel
          </Button>
          <Button
            data-test="approve-draft-dialog-yes-button"
            type="primary"
            onClick={vm.approveDraft}
          >
            Yes
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

export default ApproveDraftDialog
